import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, tap, map } from 'rxjs';
import { SettingsService } from '../../../../core/services/settings.service';
import { BpService } from '../../../../core/services/bp.service';
import { KkmsModalService } from './kkms-modal.service';
import { IForm } from '../../../../core/modules/business-process/business-process.types';
import { RetailPlacesApiService } from '../../../../core/modules/retail-places/retail-places-api.service';
import { BaseKkmFields } from '../../../../core/modules/kkms/kkms.types';

@Injectable({
  providedIn: 'root',
})
export class KkmProcessService {
  constructor(
    private settingsService: SettingsService,
    private retailPlaceApiService: RetailPlacesApiService,
    private kkmsModalService: KkmsModalService,
    private bpService: BpService,
  ) {}

  processKkmFormWithRcaCheck<T extends IForm, K extends BaseKkmFields>(kkmForm: K): Observable<T> {
    return this.settingsService.getSettings().pipe(
      switchMap((settings) => {
        const isIsnaEnabled = settings['kkm.registration.isna.enabled'] === 'true';
        if (!isIsnaEnabled) return this.bpService.submitAndGetForm<T>(kkmForm);

        return this.retailPlaceApiService.fetchRetailPlace(kkmForm.retailPlaceId).pipe(
          map(res => res.rca),
          tap((rca) => {
            if (!rca) {
              const processIds = this.bpService.getProcessIds();
              this.kkmsModalService.openRcaAlarmModal<K>(kkmForm, processIds);
            }
          }),
          filter(Boolean),
          switchMap(() => this.bpService.submitAndGetForm<T>(kkmForm)),
        );
      }),
    );
  }
}
